document.addEventListener('DOMContentLoaded', function () {
  // Function to attach the click handler to the target element
  function attachClickHandler() {
    const targetElement = document.querySelector('a.text-m.ask-question');

    if (targetElement) {
      // Attach the click event handler
      targetElement.addEventListener('click', function (event) {
        event.preventDefault();

        console.log('Ask Question clicked');

        // Start observing for the rest of the elements after the click
        observeForElements();
      });

      // Stop observing for the target element once found
      observer.disconnect();
    }
  }

  // Function to observe for the other elements being added to the DOM
  function observeForElements() {
    function checkElementsInDOM() {
      const reviewsTab = document.querySelector(
        'div.ugc-storefront-widgets-tabs-container__tab.selected',
      );
      const qaTab = document.querySelector(
        'div.ugc-storefront-widgets-tabs-container__tab:not(.selected)',
      );
      const reviewsContainer = document.querySelector(
        'div.yotpo-main-layout.yotpo-main-reviews-widget',
      );
      const qaWidget = document.getElementById('yotpo-questions-and-answers');

      // Check if all elements are available in the DOM
      if (reviewsTab && qaTab && reviewsContainer && qaWidget) {
        console.log('All elements are now in the DOM');

        // Reapply changes after a short delay to counteract third-party widget behavior
        function applyChanges() {
          // Remove the 'selected' class from the 'Reviews' tab
          if (reviewsTab) {
            reviewsTab.classList.remove('selected');
            console.log('Removed "selected" class from Reviews tab');
          }

          // Add the 'selected' class to the 'Q&A' tab
          if (qaTab) {
            qaTab.classList.add('selected');
            console.log('Added "selected" class to Q&A tab');
          }

          // Add 'display: none' to the reviews container
          if (reviewsContainer) {
            reviewsContainer.style.display = 'none';
            console.log('Set display: none on Reviews container');
          }

          // Force remove 'display: none' from the Q&A widget
          if (qaWidget) {
            qaWidget.parentElement.style.removeProperty('display');
            console.log('Forced Q&A widget to be visible');
          }

          reviewsTab.addEventListener('click', function (event) {
            event.preventDefault();
            console.log('Reviews tab clicked');
            // Remove the 'selected' class from the 'Reviews' tab
            reviewsTab.classList.add('selected');
            qaTab.classList.remove('selected');
            reviewsContainer.style.display = 'block';
            qaWidget.parentElement.style.display = ' none';
          })
        }

        // applying changes after 1000ms to fool Yotpo
        setTimeout(applyChanges, 500);

        // Stop observing once all elements are found
        secondObserver.disconnect();
      }
    }

    // Set up MutationObserver for the rest of the elements
    const secondObserver = new MutationObserver(checkElementsInDOM);
    secondObserver.observe(document.body, { childList: true, subtree: true });

    // Initial check in case the elements are already in the DOM
    checkElementsInDOM();
  }

  // Use MutationObserver to continuously check for the target element being added to the DOM
  const observer = new MutationObserver(attachClickHandler);
  observer.observe(document.body, { childList: true, subtree: true });

  // Initial check for the target element in case it is already in the DOM
  attachClickHandler();
});
